import Phaser from 'phaser';
import { hasUrlFlag } from '../game/gameConfig';
import { sceneAfter } from '../game/scenes';
import { addCoverImage, setImageHeight } from '../game/sceneArt';
import { createIconHud } from '../ui/IconHud';

export class FlightScene extends Phaser.Scene {
  private rocket!: Phaser.GameObjects.Image;

  constructor() {
    super('Flight');
  }

  preload() {
    this.load.image('rocket_flight', 'assets/rocket-pad-v3.png');
    this.load.image('bg_trip', 'assets/bg-trip.png');
    this.load.image('meteor_1', 'assets/meteor-1.png');
    this.load.image('meteor_2', 'assets/meteor-2.png');
    this.load.image('meteor_3', 'assets/meteor-3.png');
  }

  create() {
    createIconHud(this);
    const freeze = hasUrlFlag('freeze');
    const { width, height } = this.scale;

    addCoverImage(this, 'bg_trip', -20, 0.95);
    this.add.rectangle(width / 2, 58, 360, 72, 0x081224, 0.58);

    this.rocket = setImageHeight(this.add.image(width * 0.15, height - 80, 'rocket_flight'), 160).setDepth(12);

    this.add.text(width / 2, 42, 'Rumbo a la Luna', {
      fontFamily: 'monospace',
      fontSize: '28px',
      color: '#eef6ff',
    }).setOrigin(0.5);

    this.add.text(width / 2, 80, 'Esquivando meteoritos suaves durante el viaje.', {
      fontFamily: 'monospace',
      fontSize: '16px',
      color: '#b4cbef',
    }).setOrigin(0.5);

    this.spawnMeteor(240, -80, 3000, 'meteor_1', 0.82);
    this.spawnMeteor(width - 180, -120, 2500, 'meteor_2', 1.05, -140);
    this.spawnMeteor(width * 0.48, -90, 2800, 'meteor_3', 0.94, 90);

    if (freeze) {
      return;
    }

    // Bezier control points for a parabolic arc
    const p0 = { x: width * 0.15, y: height - 80 };   // start (near Earth)
    const p1 = { x: width * 0.25, y: -60 };            // control (steep rise)
    const p2 = { x: width * 0.68, y: height * 0.25 };  // end (near Moon)

    this.tweens.addCounter({
      from: 0,
      to: 1,
      duration: 3800,
      ease: 'Sine.easeInOut',
      onUpdate: (tween) => {
        const t = tween.getValue();
        const inv = 1 - t;
        // Quadratic bezier
        const bx = inv * inv * p0.x + 2 * inv * t * p1.x + t * t * p2.x;
        const by = inv * inv * p0.y + 2 * inv * t * p1.y + t * t * p2.y;
        this.rocket.setPosition(bx, by);

        // Tangent for rotation (rocket points along travel direction)
        const tx = 2 * inv * (p1.x - p0.x) + 2 * t * (p2.x - p1.x);
        const ty = 2 * inv * (p1.y - p0.y) + 2 * t * (p2.y - p1.y);
        this.rocket.rotation = Math.atan2(tx, -ty);
      },
      onComplete: () => {
        this.time.delayedCall(700, () => {
          const next = sceneAfter('Flight');
          if (next) {
            this.scene.start(next);
          }
        });
      },
    });
  }

  private spawnMeteor(
    startX: number,
    startY: number,
    duration: number,
    key: string,
    scale: number,
    driftX = -70,
  ) {
    const meteor = this.add.image(startX, startY, key).setScale(scale).setDepth(10);
    this.tweens.add({
      targets: meteor,
      x: startX + driftX,
      y: this.scale.height + 80,
      angle: driftX > 0 ? 180 : -180,
      duration,
      ease: 'Sine.easeIn',
      onComplete: () => meteor.destroy(),
    });
  }
}
